import { useState } from "react";

/**
 * Small pill showing a Discord glyph. Signals that the person/team is
 * provisioned on the Legacy Discord server. Click to toggle a tiny tooltip
 * with the connected handle/name.
 */
export function DiscordBadge({ handle, size = 12, className = "", testid = "discord-badge" }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex items-center">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setOpen((v) => !v);
        }}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
        data-testid={testid}
        aria-label={handle ? `Discord: ${handle}` : "On Discord"}
        title={handle ? `Discord: ${handle}` : "On our Discord"}
        className={`inline-flex items-center justify-center rounded-sm bg-[#5865F2]/15 border border-[#5865F2]/50 text-[#8b93f9] hover:bg-[#5865F2]/30 hover:text-white transition-colors ${className}`}
        style={{ width: size + 6, height: size + 6 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width={size}
          height={size}
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3.2a.075.075 0 0 0-.079.037c-.34.607-.719 1.4-.984 2.024a18.36 18.36 0 0 0-5.487 0 12.68 12.68 0 0 0-1-2.024.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 5.171 4.369a.07.07 0 0 0-.032.027C2.593 8.045 1.9 11.63 2.24 15.17a.082.082 0 0 0 .031.055 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.31 14.31 0 0 0 1.226-1.994.075.075 0 0 0-.041-.105 13.13 13.13 0 0 1-1.875-.893.076.076 0 0 1-.008-.127c.126-.094.252-.192.373-.291a.075.075 0 0 1 .078-.01c3.927 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .079.01c.12.099.246.198.373.292a.076.076 0 0 1-.006.127 12.31 12.31 0 0 1-1.876.892.076.076 0 0 0-.041.106c.36.7.772 1.365 1.226 1.993a.077.077 0 0 0 .084.029 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-4.088-.838-7.643-3.549-10.774a.06.06 0 0 0-.031-.028zM8.02 13.041c-1.182 0-2.157-1.085-2.157-2.419 0-1.333.957-2.418 2.157-2.418 1.21 0 2.176 1.094 2.157 2.418 0 1.334-.957 2.42-2.157 2.42zm7.974 0c-1.183 0-2.158-1.085-2.158-2.419 0-1.333.957-2.418 2.158-2.418 1.21 0 2.176 1.094 2.157 2.418 0 1.334-.947 2.42-2.157 2.42z" />
        </svg>
      </button>
      {open && (
        <span
          role="tooltip"
          data-testid={`${testid}-tooltip`}
          className="absolute z-20 top-full left-1/2 mt-1.5 -translate-x-1/2 whitespace-nowrap bg-black border border-[#5865F2] text-[10px] font-mono uppercase tracking-widest text-white px-2 py-1 shadow-lg"
        >
          {handle ? `Discord · ${handle}` : "On our Discord"}
        </span>
      )}
    </span>
  );
}

export default DiscordBadge;
